import { useAppSelector } from 'flow/hooks/useRedux';
import { QueueKey } from 'flow/types/EntityKeys';
import { selectQueueHasOmniSupport } from 'flow/selectors/queue-selectors';
import useAppContext from 'flow/hooks/useAppContext';
import SectionTitle from '../../SectionTitle';

interface Props {
    queueKey: QueueKey;
}

const TitleOngoingQueueItems = ({ queueKey }: Props) => {
    const { i18next } = useAppContext();

    const queueHasOmniSupport = useAppSelector((state) =>
        selectQueueHasOmniSupport(state, queueKey),
    );

    return (
        <SectionTitle>
            {queueHasOmniSupport
                ? i18next.t('Queue.QueueMembers.Section.Title')
                : i18next.t('Queue.QueueMembersInCall.Section.Title')}
        </SectionTitle>
    );
};

export default TitleOngoingQueueItems;
